module.exports = self["jspdf"];